import { SheetFooter, SheetHeader, SheetTitle } from '@/components/ui/sheet'
import { Skeleton } from '@/components/ui/skeleton'

export const UpdateWebhookSheetFallback = () => {
  return (
    <>
      <SheetHeader>
        <SheetTitle>Update webhook</SheetTitle>
      </SheetHeader>
      <div className="px-4 overflow-y-auto w-full pb-2">
        <Skeleton className="h-3.5 w-[100px] mb-2" />
        <Skeleton className="h-9 w-full mb-4" />
      </div>
      <div className="px-4 overflow-y-auto w-full pb-2">
        <Skeleton className="h-3.5 w-[100px] mb-2" />
        <Skeleton className="h-16 w-full mb-4" />
      </div>
      <SheetFooter className="sticky">
        <Skeleton className="h-9 w-full" />
      </SheetFooter>
    </>
  )
}
